module.exports = __webpack_public_path__ + "static/media/dual_swing.98986d0d.png";